var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightDocumentsFlightItinerary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.854 5.646L13.354 1.146C13.26 1.052 13.133 1 13 1H3.5C2.673 1 2 1.673 2 2.5V18.5C2 19.327 2.673 20 3.5 20H16.5C17.327 20 18 19.327 18 18.5V6C18 5.867 17.947 5.74 17.854 5.646ZM16.793 6H13.5C13.224 6 13 5.776 13 5.5V2.207L16.793 6ZM17 18.5C17 18.776 16.776 19 16.5 19H3.5C3.224 19 3 18.776 3 18.5V2.5C3 2.224 3.224 2 3.5 2H12V5.5C12 6.327 12.673 7 13.5 7H17V18.5Z",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDocumentsFlightItinerary);
export default __webpack_public_path__ + "static/media/flight-documents-flight-itinerary.2bc37385087eb76522bc993649c9dad7.svg";
export { ForwardRef as ReactComponent };